<!-- header -->
<mat-toolbar color="primary">
    <mat-toolbar-row class="tool">
        <button mat-icon-button (click)="toggleSideBar()">
            <mat-icon>menu</mat-icon>
        </button>

        <span routerLink="/home">
            Cortizo
        </span>

        <div fxFlex fxLayout="row" fxLayoutAlign="flex-end">
            <ul fxLayout="row" fxLayoutGap="20px">
                <!-- <li>
                    <button mat-icon-button>
                        <mat-icon>settings</mat-icon>
                    </button>
                </li> -->
                <li>
                    <button mat-icon-button [matMenuTriggerFor]="langMenu">
                        <mat-icon>g_translate</mat-icon>
                    </button>
                    <mat-menu #langMenu="matMenu" class="menu">
                        <button mat-menu-item (click)="changeLang('en')" [ngClass]="currentLang === 'en' ? 'active' : ''">English</button>
                        <button mat-menu-item (click)="changeLang('es')" [ngClass]="currentLang === 'es' ? 'active' : ''">Spanish</button>
                    </mat-menu>
                </li>
                <li>
                    <button mat-button [matMenuTriggerFor]="menu">
                        <mat-icon>person_outline</mat-icon>
                        {{userEmail}}
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="doLout()">
                            <mat-icon>exit_to_app</mat-icon>
                            {{'Sign out' | translate}}
                        </button>
                    </mat-menu>

                </li>
            </ul>
        </div>
    </mat-toolbar-row>
</mat-toolbar>
